import { createAction, createReducer } from '@reduxjs/toolkit';

import postAnnShipShipment from '../../../thunks/shipment/annShip/postAnnShipShipment';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};
export const postAnnShipShipmentClearError = createAction('postAnnShipShipmentClearError');

const postAnnShipShipmentReducer = createReducer(initialState, {
  [postAnnShipShipment.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postAnnShipShipment.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postAnnShipShipment.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
  [postAnnShipShipmentClearError]: (state) => ({
    ...state,
    error: null,
  }),

});

export default postAnnShipShipmentReducer;
